import React from 'react';

type Props = {
  size?: string | number;
  className?: string;
  color?: string;
};

const FacebookIcon = ({ className, size = 36, color = '#B3B5B6' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
  >
    <defs>
      <path
        id="3lw0hdly5a"
        d="M12.683 22h-9.58C2.495 22 2 21.506 2 20.896V3.104C2 2.494 2.494 2 3.104 2h17.792C21.506 2 22 2.494 22 3.104v17.792c0 .61-.494 1.104-1.104 1.104H15.8v-7.745h2.6l.389-3.019h-2.99V9.31c0-.873.243-1.469 1.497-1.469h1.598v-2.7c-.277-.037-1.225-.12-2.33-.12-2.304 0-3.881 1.407-3.881 3.99v2.226h-2.607v3.019h2.607V22z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-440 -650) translate(416 638) translate(24 12)">
            <mask id="es1aumng1b" fill="#fff">
              <use xlinkHref="#3lw0hdly5a" />
            </mask>
            <use fill={color} xlinkHref="#3lw0hdly5a" />
            <g fill={color} mask="url(#es1aumng1b)">
              <path d="M0 0H24V24H0z" />
            </g>
            <path d="M0 0H24V24H0z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FacebookIcon;
